import { useQuery } from '@tanstack/react-query';

import { supabase } from '../../api';

const getCategory = async (id: string | undefined) => {
  const { data, error } = await supabase
    .from('categories')
    .select('*')
    .order('sorting', { ascending: true })
    .eq('id', id)
    .single()

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useCategory(id: string | undefined) {
  return useQuery({
    queryKey: ['useCategory'],
    queryFn: () => getCategory(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  });
}
